import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

import {OnboardingOption} from '../../onboarding-option';

import styles from '../../onboarding-body.module.css';

export function OnboardingBodyActivities() {
    return (
        <OnboardingBody title='We pitch with a:'>
            <div>
                <div className={styles['check-all']}>
                    <em>(check all that apply)</em>
                </div>
                <OnboardingOption option='usesPhoneCallActivities' label='Phone call' />
                <OnboardingOption
                    option='usesOnSiteDemoActivities'
                    label='On-site demo/consultation'
                />
                <OnboardingOption option='usesScreenShareActivities' label='Screen share' />
                <OnboardingOption option='usesNoActivities' label='None of the above' />
            </div>
        </OnboardingBody>
    );
}
